/**
 * Shared border + background tints for page Alerts and ephemeral Toasts.
 * Keep in sync: same semantic meaning per variant in both surfaces.
 */

/** Core surface (no Alert-specific svg selectors). */
export const NOTICE_SURFACE = {
  default: "border-border bg-card text-card-foreground",
  destructive: "border-destructive/30 bg-destructive/10 text-destructive",
  success: "border-success/30 bg-success/10 text-success",
  warning: "border-warning/30 bg-warning/10 text-warning",
  info: "border-info/30 bg-info/10 text-info",
};

/** Icon tint classes for Alert (leading svg). */
export const ALERT_ICON_TINT = {
  default: "[&>svg]:text-foreground",
  destructive: "[&>svg]:text-destructive",
  success: "[&>svg]:text-success",
  warning: "[&>svg]:text-warning",
  info: "[&>svg]:text-info",
};
